import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]

  updateGlobal(event) {
    const input = event.target
    const phaseKind = input.dataset.phaseKind
    const value = input.value || 0

    this.showSaving()
    input.classList.add("bg-yellow-100")

    const programId = window.location.pathname.match(/\/programs\/(\d+)/)[1]

    fetch(`/admin/programs/${programId}/targets/update_global`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify({ phase_kind: phaseKind, value: value })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.showSaved()
        input.classList.remove("bg-yellow-100")
        input.classList.add("bg-green-100")
        setTimeout(() => input.classList.remove("bg-green-100"), 1000)
      } else {
        this.showError()
        input.classList.remove("bg-yellow-100")
        input.classList.add("bg-red-100")
      }
    })
    .catch(() => {
      this.showError()
      input.classList.remove("bg-yellow-100")
      input.classList.add("bg-red-100")
    })
  }

  updateYearly(event) {
    const input = event.target
    const phaseKind = input.dataset.phaseKind
    const year = input.dataset.year
    const value = input.value || 0

    this.showSaving()
    input.classList.add("bg-yellow-100")

    const programId = window.location.pathname.match(/\/programs\/(\d+)/)[1]

    fetch(`/admin/programs/${programId}/targets/update_yearly`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify({ phase_kind: phaseKind, year: year, value: value })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.showSaved()
        input.classList.remove("bg-yellow-100")
        input.classList.add("bg-green-100")
        setTimeout(() => input.classList.remove("bg-green-100"), 1000)
      } else {
        this.showError()
        input.classList.remove("bg-yellow-100")
        input.classList.add("bg-red-100")
      }
    })
    .catch(() => {
      this.showError()
      input.classList.remove("bg-yellow-100")
      input.classList.add("bg-red-100")
    })
  }

  showSaving() {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = "Enregistrement..."
      this.statusTarget.classList.remove("text-green-600", "text-red-600")
      this.statusTarget.classList.add("text-gray-500")
    }
  }

  showSaved() {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = "Enregistré"
      this.statusTarget.classList.remove("text-gray-500", "text-red-600")
      this.statusTarget.classList.add("text-green-600")
      setTimeout(() => {
        this.statusTarget.textContent = ""
      }, 2000)
    }
  }

  showError() {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = "Erreur"
      this.statusTarget.classList.remove("text-gray-500", "text-green-600")
      this.statusTarget.classList.add("text-red-600")
    }
  }
}
